module.exports = __webpack_public_path__ + "img/logo-indice-avancado.27e037e3.svg";